<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CYqtDJ/tc-custom/9780830899173.jpg?1696024733269" alt="This image is the cover for the book Broken and Whole"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Broken and Whole
      </h1>
      <p class="bookDescription body article font2">
        <p>In his nearly four decades of pastoral, parachurch and nonprofit ministry leadership Steve Macchia has come to understand his own brokenness. He writes: "I've experienced great success and a few embarrassing failures. . . . In essence, as much as I like to view myself as a good or even a very good leader, I'm more truthfully a blessed and broken leader, one who is daily in need of being . . . redeemed by the Spirit of God who resides in me." In these pages Steve offers the gifts of love found in 1 Corinthians 13 as the antidote to our brokenness. He writes with personal transparency from his own experience. Each chapter concludes with a powerful spiritual assessment tool to use in reflecting on our own leadership strengths and weaknesses. By embracing and befriending our own brokenness we can find true wholeness in God's strength. In these pages you will discover a new way to live in freedom and joy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen A. Macchia
      </h2>
      
      <p class="authorDescription body article"><p>Stephen A. Macchia (DMin, Gordon-Conwell Theological Seminary) is founder and president of Leadership Transformations, Inc., a ministry which focuses on the spiritual formation needs of leaders and the spiritual discernment processes of leadership teams in local church and parachurch ministry settings nationwide. He is also the director of the Pierce Center for Disciple-Building at Gordon-Conwell Theological Seminary and previously served for fourteen years as president of Vision New England. Macchia is the author of ten books, including <em>Becoming a Healthy Church</em> and <em>Crafting a Rule of Life</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c824d0c